import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { SorCode } from "@app/models/rest/sor-code";
import { SorCodeRestService } from "@app/services/hal/sor-code-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SorCodeStore extends RealTimeDataStore<SorCode> {
  constructor() {
    const sorCodeRestService = inject(SorCodeRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(sorCodeRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("SorCode");
  }
}
